import { render, staticRenderFns } from "./RF-Dashboard.vue?vue&type=template&id=1d4a944e&scoped=true&"
import script from "./RF-Dashboard.vue?vue&type=script&lang=js&"
export * from "./RF-Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a944e",
  null
  
)

export default component.exports